import { components } from 'react-select';
import { Typography } from '../../../components/typography/typography';

const LocationSingleValue = (props: any) => (
  <components.SingleValue {...props}>
    {props.hasValue ? (
      <Typography type="text-sm" className="text-quipli-black-800" data-cy="selected-location-name">
        {props.getValue()[0].name}
      </Typography>
    ) : (
      props.children
    )}
  </components.SingleValue>
);

const LocationPlaceholder = (props: any) => (
  <components.Placeholder {...props}>
    <div className="flex items-center gap-[6px]">
      <Typography type="text-sm">Search locations</Typography>
    </div>
  </components.Placeholder>
);

export const EmailNotificationsSelectComponents = {
  SingleValue: LocationSingleValue,
  Placeholder: LocationPlaceholder,
};

export const emailNotificationsSelectStyles = {
  group: (baseStyles: any) => ({
    ...baseStyles,
    padding: '0',
  }),
};
